import type { DashboardMetric, Trend } from 'types';
import { ETrendName } from 'enums';
import { CURRENCY_CONFIG } from './currency-config';

export function toChartPoints(
  chartData: number[]
): Array<{ name: number; value: number }> {
  return chartData?.map((value, i) => ({ name: i + 1, value }));
}

export function calculateTrend(chartData: number[]): {
  trend: Trend;
  percentage: number;
} {
  if (chartData?.length < 2) {
    return { trend: ETrendName.NEUTRAL, percentage: 0 };
  }
  const firstValue = chartData?.[0];
  const lastValue = chartData?.[chartData?.length - 1];
  if (firstValue === 0) {
    return {
      trend: lastValue > 0 ? ETrendName.UP : ETrendName.NEUTRAL,
      percentage: 0,
    };
  }
  const percentage = ((lastValue - firstValue) / firstValue) * 100;
  if (percentage > 0) return { trend: ETrendName.UP, percentage };
  if (percentage < 0)
    return { trend: ETrendName.DOWN, percentage: Math.abs(percentage) };
  return { trend: ETrendName.NEUTRAL, percentage: 0 };
}

export function getTrendColor(trend: Trend): string {
  switch (trend) {
    case ETrendName.UP:
      return '#10B981';
    case ETrendName.DOWN:
      return '#EF4444';
    default:
      return '#6B7280';
  }
}

export function getTrendIcon(trend: Trend): string {
  switch (trend) {
    case ETrendName.UP:
      return '↑';
    case ETrendName.DOWN:
      return '↓';
    default:
      return '→';
  }
}

export function formatValue(metric: DashboardMetric): string {
  const { today, currency } = metric;
  const symbol = currency ? CURRENCY_CONFIG[currency]?.symbol : undefined;

  if (symbol) {
    return `${symbol} ${new Intl.NumberFormat('en-US', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    }).format(today)}`;
  }
  return new Intl.NumberFormat('en-US').format(today);
}
